import { getRequest, patchRequest, deleteRequest, postRequest, postFormData } from './http.service';
import {
  URL_ENVELOPES,
  URL_ENVELOPE_BY_ID,
  URL_ENVELOPE_VOID,
  URL_ENVELOPE_SEND,
  URL_ENVELOPE_SAVE_TO_FILES,
  URL_CONTACTS_BY_CLIENT,
  URL_AGREEMENTS_READY,
  URL_ENVELOPES_BY_CLIENT,
  URL_ENVELOPES_RECENT_BY_CLIENT,
  URL_DOC_TEMPLATE_BY_ORG,
  URL_SUBMISSIONS_EMAILS,
  URL_DOCUSEAL_BUILDER_TOKEN,
} from './url.service';

export const fetchEnvelopes = (clientId: string, status: string) =>
  getRequest(`${URL_ENVELOPES}?clientId=${clientId}&status=${status}`);

/** Get the most recent envelopes for a client (summarised, for the quick-access widget) */
export const fetchRecentEnvelopesForClient = (clientId: string, limit = 5) =>
  getRequest(URL_ENVELOPES_RECENT_BY_CLIENT(clientId, limit));

/** Get all envelopes for a client (used to derive e-signature summary counts) */
export const fetchAllEnvelopesForClient = (clientId: string) =>
  getRequest(URL_ENVELOPES_BY_CLIENT(clientId));

export const fetchEnvelopeById = (envelopeId: string) =>
  getRequest(URL_ENVELOPE_BY_ID(envelopeId));

export const deleteEnvelope = (envelopeId: string) =>
  deleteRequest(URL_ENVELOPE_BY_ID(envelopeId));

export const voidEnvelope = (envelopeId: string) =>
  patchRequest(URL_ENVELOPE_VOID(envelopeId), {});

export const sendEnvelope = (envelopeId: string) =>
  patchRequest(URL_ENVELOPE_SEND(envelopeId), {});

export const saveEnvelopeToClientFiles = (envelopeId: string) =>
  postRequest(URL_ENVELOPE_SAVE_TO_FILES(envelopeId), {});

export const fetchContactsForEnvelope = (clientId: string) =>
  getRequest(URL_CONTACTS_BY_CLIENT(clientId));

export const fetchReadyTemplates = (orgId: string) =>
  getRequest(URL_AGREEMENTS_READY(orgId));

export const createEnvelope = (formData: FormData) =>
  postFormData(URL_ENVELOPES, formData);

/** Get e-sign document templates (DocuSeal slug-based) for an org */
export const fetchEsignTemplatesByOrg = (orgId: string) =>
  getRequest(URL_DOC_TEMPLATE_BY_ORG(orgId));

/** Send a document out for signing via submission emails */
export const sendEsignSubmissionEmails = (payload: Record<string, unknown>) =>
  postRequest(URL_SUBMISSIONS_EMAILS, payload);

/** Get a DocuSeal builder token for the form-builder UI */
export const fetchDocusealBuilderToken = (payload: Record<string, unknown>) =>
  postRequest(URL_DOCUSEAL_BUILDER_TOKEN, payload);
